module.exports = __webpack_public_path__ + "media/applicants/no-car-required-7aa6dcdd.svg";